export var connections = [
  ["benchmark", "benchmark", "gauge", "standard", "yardstick"],
  ["poker actions", "bet", "call", "fold", "raise"],
  ["skin types", "combination", "dry", "normal", "oily"],
  ["types of tea", "black", "green", "herbal", "white"],
  ["cardinal directions", "east", "north", "south", "west"],
  ["seasons", "autumn", "spring", "summer", "winter"],
  ["elements", "earth", "fire", "water", "air"],
  ["suits in a deck of cards", "clubs", "diamonds", "hearts", "spades"],
  ["strings on a violin", "A", "D", "G", "E"],
  ["oceans", "arctic", "atlantic", "indian", "pacific"],
  ["US states", "california", "florida", "new york", "texas"],
  ["planets", "earth", "jupiter", "mars", "venus"],
  ["days of the week", "friday", "monday", "saturday", "sunday"],
  ["months", "april", "july", "october", "january"],
  ["elements of a set", "intersection", "subset", "union", "element"],
  ["types of triangles", "equilateral", "isosceles", "scalene", "right"],
  ["types of angles", "acute", "obtuse", "right", "straight"],
  [
    "types of quadrilaterals",
    "parallelogram",
    "rectangle",
    "rhombus",
    "square",
  ],
  ["types of polygons", "hexagon", "octagon", "pentagon", "triangle"],
  ["types of lines", "line segment", "parallel", "perpendicular", "ray"],
];
